<input
  #siteLogoInput
  id="siteLogoInput"
  class="d-none"
  type="file"
  accept="image/*"
  (change)="handleSiteLogoInput($event.target)"
/>

<div id="siteDetail" class="pt-2 pe-lg-3">
  <div class="details-card mb-4">
    <div class="row row-cols-1 row-cols-lg-2 mb-lg-3">
      <div class="col-lg-8">
        <div class="col row row-cols-2">
          <div class="col-12 col-lg-9">
            <dl id="siteName">
              <div class="d-flex align-items-center">
                <div
                  class="fs-4 pe-2 link-edit"
                  id="editSiteName"
                  (click)="editSite(true)"
                >
                  {{ siteDetailData?.company_name }}
                </div>
              </div>
            </dl>

            <dl id="siteAddress">
              <div class="d-flex align-items-center">
                <div class="flex-grow-1">
                  <dt>Site Address</dt>

                  <dd
                    id="editSiteAddress"
                    class="link-edit"
                    (click)="editSite()"
                  >
                    {{ siteDetailData?.address?.full_address }}
                  </dd>
                </div>
              </div>
            </dl>
          </div>
        </div>

        <div class="col d-lg-none mb-4">
          <gtapp-map-leaflet
            [latLon]="{
              lat: siteDetailData?.address?.latitude,
              lon: siteDetailData?.address?.longitude,
            }"
            [mapId]="'siteLocation'"
          ></gtapp-map-leaflet>
        </div>

        <div class="d-flex flex-wrap gap-3">
          <dl id="siteInformation">
            <dt>Site Information</dt>
            <dd
              class="gt-multi-line"
              [class.link-edit]="siteDetailData?.information?.trim()"
              (click)="openInformationTemplate(siteInfoTemplate)"
            >
              @if (siteDetailData?.information?.trim()) {
                {{ siteDetailData?.information }}
              } @else {
                <button class="btn btn-sm btn-secondary align-items-center">
                  <i class="fa-solid fa-plus"></i>
                </button>
              }
            </dd>
          </dl>
          <dl id="siteFiles">
            <dt>
              {{ "Site Files [" + selectedSiteFiles?.length + " / 20 Max]" }}
            </dt>
            <dd class="d-flex flex-wrap gap-2 mb-3 overflow-45vh">
              @for (file of selectedSiteFiles; track file; let i = $index) {
                <div>
                  <div
                    class="d-flex fw-semibold text-primary gap-3 border rounded p-2"
                  >
                    <div (click)="onOpenFile(file)" role="button">
                      <span class="badge bg-primary me-2">{{
                        file?.extension
                      }}</span>
                      {{ file?.description }}
                    </div>

                    <div
                      class="d-flex align-items-center me-2"
                      (click)="deleteFile(file)"
                    >
                      <i class="fa-solid fa-circle-minus text-danger"></i>
                    </div>
                  </div>
                </div>
              }
            </dd>
            @if (selectedSiteFiles?.length < 20) {
              <div
                id="editSiteFiles"
                class="rounded border shadow p-2 mb-2 text-center hover"
                role="button"
                (click)="openFileUploadTemplate(uploadRef)"
              >
                <i class="fa-solid fa-plus"></i>
              </div>
            }
          </dl>
        </div>
      </div>

      <div class="col-lg-4 d-none d-lg-block">
        <gtapp-map-leaflet
          [latLon]="{
            lat: siteDetailData?.address?.latitude,
            lon: siteDetailData?.address?.longitude,
          }"
          [mapId]="'siteLocationLargeView'"
        ></gtapp-map-leaflet>
      </div>
    </div>
  </div>
  @if (largeView && siteHistory?.length) {
    <gtapp-gt-table
      id="siteHistory"
      [desktopTableUIData]="siteHistory"
      [desktopTableDetails]="userEventDetailsTableView"
      [otherParams]="{ paginationData: true }"
      (rowClick)="onTableRowClick($event)"
    ></gtapp-gt-table>
  }
  @if (selectedEvent) {
    <gtapp-selected-event-detail
      [selectedEvent]="selectedEvent"
    ></gtapp-selected-event-detail>
  }
</div>

<!-- Client Information POPOVER / DIALOG -->
<ng-template #siteInfoTemplate let-data let-siteInfoTemplateRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Site Information
      <span class="float-end" (click)="siteInfoTemplateRef.close(false)">
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <!-- Request Detail Section start-->
    <div class="row">
      <div class="col">
        <textarea
          class="form-control"
          placeholder="Information about the site."
          cols="20"
          rows="5"
          wrap="hard"
          type="text"
          [(ngModel)]="data.newValue"
        ></textarea>
      </div>
    </div>

    <div class="row row-cols-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="siteInfoTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="
            data?.newValue == data?.oldValue ||
            (data?.newValue?.length && !data?.newValue?.trim())
          "
          (click)="siteInfoTemplateRef.close(data)"
        >
          Update
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>

<!-- Client file Upload DIALOG -->
<ng-template #uploadRef let-data let-uploadRef="dialogRef">
  <div class="dialog-box card">
    <div class="card-header">
      Upload File
      <span
        class="float-end"
        (click)="
          uploadRef.close();
          fileUploadError = null;
          fileDescription = null;
          uploadFile = null
        "
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    @if (fileUploadError) {
      <div class="mt-3">
        <div class="alert alert-warning">
          {{ fileUploadError }}
        </div>
      </div>
    }
    <div class="col mb-2">
      <button
        type="button"
        class="btn btn-md w-100"
        [ngClass]="uploadFile ? 'btn-outline-primary' : 'btn-primary'"
        (click)="selectFile()"
      >
        {{ uploadFile ? "Change File" : "Select File From Device" }}
      </button>

      <input
        #fileInput
        id="fileInput"
        style="display: none; cursor: pointer"
        type="file"
        accept=".pdf, .jpg, .jpeg, .png, .webp, .avif"
        (change)="handleFileInput($event)"
      />
    </div>

    <div class="form-floating mb-2">
      <input
        class="form-control"
        placeholder="File Description"
        required
        maxlength="30"
        type="text"
        [(ngModel)]="fileDescription"
      /><label>File Description</label>
    </div>

    <div class="row row-cols-2 g-2 mt-4">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="
            uploadRef.close();
            fileUploadError = null;
            fileDescription = null;
            uploadFile = null
          "
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-primary"
          [disabled]="!uploadFile || !fileDescription"
          (click)="onUploadFile(); uploadRef.close()"
        >
          Upload {{ uploadFile?.name }}
        </button>
      </div>
    </div>
  </div>
</ng-template>

<!-- priority site message section -->
<ng-template
  #prioritySiteMessageTemplate
  let-data
  let-prioritySiteMessageTemplateRef="dialogRef"
>
  <div class="dialog-box card">
    <div class="card-header">
      Priority Alarm Response Site
      <span
        class="float-end"
        (click)="prioritySiteMessageTemplateRef.close(false)"
      >
        <i class="fa-solid fa-xmark"></i>
      </span>
    </div>

    <div class="row mb-2">
      <div class="col">
        <div class="p-2 mb-3">
          This message will be shown when site is selected for an alarm
          response.
        </div>
        <div class="col form-group input-group">
          <textarea
            class="form-control"
            placeholder="Example: Penalty rates apply if guard is not onsite within 40 minutes."
            cols="20"
            rows="5"
            wrap="hard"
            type="text"
            autofocus
            id="priorityMessageField"
            [(ngModel)]="data.newValue"
          ></textarea>
          @if (data?.newValue) {
            <span
              class="input-group-text"
              (click)="data.newValue = ''; shiftFocus('priorityMessageField')"
            >
              <i class="fa-solid fa-xmark"></i>
            </span>
          }
        </div>
      </div>
    </div>

    <div class="row row-cols-2 g-2">
      <div class="col">
        <button
          class="btn btn-lg w-100 btn-dark"
          (click)="prioritySiteMessageTemplateRef.close(false)"
        >
          Cancel
        </button>
      </div>

      <div class="col">
        <button
          class="btn btn-lg w-100 btn-success"
          [disabled]="
            (data?.newValue?.length && !data?.newValue?.trim()) ||
            data?.newValue == data?.oldValue ||
            (!siteDetailData?.additional_info?.priority_info?.notes
              ? !data?.newValue?.trim()
              : false)
          "
          (click)="prioritySiteMessageTemplateRef.close(data)"
        >
          Submit
        </button>
      </div>
    </div>

    <!-- Request Detail Section end-->
  </div>
</ng-template>
